var map = {
	"app/admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"app-admin-admin-module~app-auth-auth-module",
		"app-admin-admin-module"
	],
	"app/auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"app-admin-admin-module~app-auth-auth-module",
		"app-auth-auth-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;